import React from 'react';
import { Icon } from 'ui';

const AskTheExpertButton = ({ onClick, disabled, icon }) => (
  <div className="LessonHeader-button Expert-toggle">
    <button
      type="button"
      onClick={onClick}
      className="u-resetBtn ExpertIcon-toggle o-0"
      disabled={disabled}
      data-toggle="tooltip"
      data-placement="bottom"
      data-title={t('expert.learner.tooltip')}
    >
      <Icon className="ExpertIcon" name={icon} />
    </button>
  </div>
);

export default AskTheExpertButton;
